import { NodeIndexOutlined, SettingOutlined } from '@ant-design/icons'

import pathName, {
  ADMIN,
  CATEGORY_USER,
  COLLECTION_CENTER,
  CONSUMER,
  CPCB_GOVERNMENT,
  CPCB_GOVERNMENT_USER,
  CUSTOMER_USER,
  DATA_ENTRY,
  DEALER,
  DEALER_USER,
  DISPOSER,
  DISPOSER_USER,
  DISTRICT_GOVERNMENT,
  DISTRICT_GOVERNMENT_USER,
  LIVE_BOARD,
  NATIONAL_GOVERNMENT,
  NATIONAL_GOVERNMENT_USER,
  OPERATIONS,
  OPERATIONS_USER,
  PROCUREMENT,
  PRODUCER,
  PRODUCER_USER,
  RECYCLER,
  REFURBISHER,
  REFURBISHER_USER,
  SALES,
  SALES_USER,
  SCRAPPING_FACILITY_ENTRY_USER,
  SCRAPPING_FACILITY_MANAGER,
  SECOND_HAND_BUYER,
  SECOND_HAND_BUYER_USER,
  SPCB_GOVERNMENT,
  SPCB_GOVERNMENT_USER,
  SUPER_USER,
  SUPPLIER,
  SUPPLIER_USER,
  THIRD_PARTY_RECYCLER,
  THIRD_PARTY_RECYCLER_USER,
  TRADER,
  TRADER_USER,
  TRANSPORT_CONTRACTOR,
  USER_TXT,
} from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'
import {
  AdminIcon,
  ClipboardIcon,
  ContractorIcon,
  CustomerIcon,
  DashboardIcon,
  DataviewIcon,
  DealerIcon,
  DigitalRetailerIcon,
  FieldEngineerIcon,
  HomeIcon,
  InventoryIcon,
  ProductManufactureIcon,
  ReportIcon,
  TransportContractorIcon,
  // TransportContractorIcon,
  UserIcon,
} from '../../utils/icons'
import { include, isEqual } from '../../utils/javascript'
import { userRelationKey } from '../userManagement/user.description'

const {
  HOME,
  JOBS,
  INVENTORY,
  BUCKET_MANAGEMENT,
  DATA_VISUALIZATION,
  // DASHBOARD_COMPLIANCE,
  DASHBOARD_STATS,
  DASHBOARD_INDIA,
  CATEGORY_MANAGEMENT,
  REPORT,
  LIVE_BOARD_PATH,
  SETTINGS,
  SEARCH_REACT_FLOW,
  DASHBOARD,
  TRACE_SAMPLE,
  TRACE_ACTUAL,
  PLASTIC_TRACE_SAMPLE,
  PLASTIC_TRACE_ACTUAL,
  TRACE_END_TO_END,
  TRACE_END_TO_END2,
  VEHICLE_SALES,
} = pathName

const {
  admin,
  consumer,
  consumerUser,
  dealer,
  dealerUser,
  recycler,
  recyclingTechnician,
  refurbisher,
  refurbisherUser,
  trader,
  traderUser,
  supplier,
  supplierUser,
  producer,
  producerUser,
  thirdPartyRecycle,
  thirdPartyRecycleUser,
  disposer,
  disposerUser,
  secondHandBuyer,
  secondHandBuyerUser,
  transporter,
  nationalGov,
  nationalGovUser,
  cpcbGov,
  cpcbGovUser,
  spcbGov,
  spcbGovUser,
  districtGov,
  districtGovUser,
  site,
  superUser,
  accounts,
  finance,
  dataEntry,
  collectionCenter,
  scrappingFacilityManager,
  categoryUser,
  salesUser,
  operationsUser,
  scrappingFacilityEntryUser,
  procurement,
  operations,
  sales,
} = userWiseRole

const { associate } = userRelationKey
const TraceIcon = props => (
  <NodeIndexOutlined
    {...props}
    style={{
      ...props?.style,
      alignItems: 'center',
      display: 'inline-flex',
      fontSize: 24,
      height: 30,
      justifyContent: 'center',
      width: 30,
    }}
  />
)

const allUser = [
  admin,
  consumer,
  consumerUser,
  dealer,
  dealerUser,
  recycler,
  recyclingTechnician,
  refurbisher,
  refurbisherUser,
  trader,
  traderUser,
  supplier,
  supplierUser,
  producer,
  producerUser,
  thirdPartyRecycle,
  thirdPartyRecycleUser,
  disposer,
  disposerUser,
  secondHandBuyer,
  secondHandBuyerUser,
  transporter,
  nationalGov,
  nationalGovUser,
  cpcbGov,
  cpcbGovUser,
  spcbGov,
  spcbGovUser,
  districtGov,
  districtGovUser,
  superUser,
  accounts,
  finance,
  collectionCenter,
  dataEntry,
  finance,
  accounts,
  operationsUser,
  salesUser,
  scrappingFacilityEntryUser,
  categoryUser,
  scrappingFacilityManager,
  procurement,
  operations,
  sales,
]

const isMaterialSteel = loginUserDetails =>
  isEqual('job_Steel', loginUserDetails?.materialTypes?.[0]?.materialTypeKey)

const userChildrenList = [
  {
    key: ADMIN,
    userId: admin,
    Icon: AdminIcon,
    label: 'user_Admin',
    sidebar: allUser,
    addEdit: [admin],
    level: { menu: allUser },
    userView: {
      user_Customer: [{ payload: { roleId: consumer } }],
      user_Dealer: [{ payload: { roleId: dealer } }],
      user_ScrappingFacility: [{ payload: { roleId: recycler } }],
      user_MaterialProducer: [{ payload: { roleId: refurbisher } }],
      user_TradingCompany: [{ payload: { roleId: trader } }],
    },
  },
  {
    key: CONSUMER,
    userId: consumer,
    Icon: CustomerIcon,
    label: 'user_Consumer',
    sidebar: [
      admin,
      consumerUser,
      dealer,
      dealerUser,
      recycler,
      recyclingTechnician,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      supplier,
      supplierUser,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [
      admin,
      recycler,
      recyclingTechnician,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    level: { menu: [admin] },
    userView: {
      user_ConsumerUser: [{ payload: { roleId: consumerUser } }],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_Site: [
        { payload: { roleId: site }, isBuilding: true, addEdit: true },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: CUSTOMER_USER,
    userId: consumerUser,
    Icon: CustomerIcon,
    label: 'user_ConsumerUser',
    sidebar: [admin, consumer],
    addEdit: [admin, consumer],
    level: { menu: [consumer], 'sub-menu': [admin] },
    userView: {
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Consumer', id: consumer },
  },
  {
    key: DEALER,
    userId: dealer,
    Icon: DealerIcon,
    label: 'user_Dealer',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealerUser,
      recycler,
      recyclingTechnician,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      producer,
      producerUser,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_DealerUser: [{ payload: { roleId: dealerUser } }],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DEALER_USER,
    userId: dealerUser,
    Icon: DealerIcon,
    label: 'user_DealerUser',
    sidebar: [admin, dealer],
    addEdit: [admin, dealer],
    level: { menu: [dealer], 'sub-menu': [admin] },
    userView: {
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Dealer', id: dealer },
  },
  {
    key: COLLECTION_CENTER,
    userId: collectionCenter,
    Icon: ProductManufactureIcon,
    label: 'user_CollectionCenter',
    sidebar: [
      admin,
      dealer,
      recycler,
      producer,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: RECYCLER,
    userId: recycler,
    Icon: ProductManufactureIcon,
    label: 'user_ScrappingFacility',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealer,
      dealerUser,
      recyclingTechnician,
      refurbisher,
      refurbisherUser,
      trader,
      traderUser,
      supplier,
      supplierUser,
      thirdPartyRecycle,
      thirdPartyRecycleUser,
      disposer,
      disposerUser,
      secondHandBuyer,
      secondHandBuyerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      producer,
      producerUser,
      dataEntry,
      superUser,
      finance,
      accounts,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
      scrappingFacilityManager,
      procurement,
      operations,
      sales,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: SCRAPPING_FACILITY_MANAGER,
    userId: scrappingFacilityManager,
    Icon: UserIcon,
    label: 'user_ScrappingFacilityManager',
    sidebar: [
      admin,
      recycler,
      superUser,
      dataEntry,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin, recycler],
    level: {
      menu: [recycler],
      'sub-menu': [
        admin,
        superUser,
        dataEntry,
        operationsUser,
        salesUser,
        scrappingFacilityEntryUser,
        categoryUser,
      ],
    },
    userView: {
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_ScrappingFacility', id: recycler },
  },
  {
    key: SUPER_USER,
    userId: superUser,
    Icon: UserIcon,
    label: 'user_SuperUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      dataEntry,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager],
    level: {
      'sub-menu': [recycler, scrappingFacilityManager],
      'sub-menu2': [
        admin,
        dataEntry,
        operationsUser,
        salesUser,
        scrappingFacilityEntryUser,
        categoryUser,
      ],
    },
    userView: {
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: {
      label: 'user_ScrappingFacilityManager',
      id: scrappingFacilityManager,
    },
  },
  {
    key: SCRAPPING_FACILITY_ENTRY_USER,
    userId: scrappingFacilityEntryUser,
    Icon: UserIcon,
    label: 'user_ScrappingFacilityEntryUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      superUser,
      scrappingFacilityEntryUser,
      dataEntry,
      salesUser,
      operationsUser,
      categoryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager, superUser],
    level: {
      'sub-menu2': [recycler, scrappingFacilityManager, superUser],
      'sub-menu3': [
        admin,
        scrappingFacilityEntryUser,
        dataEntry,
        categoryUser,
        salesUser,
        operationsUser,
      ],
    },
    userView: {
      user_DataEntryUser: [
        {
          payload: { roleId: dataEntry },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_CategoryUser: [
        {
          payload: { roleId: categoryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_SalesUser: [
        {
          payload: { roleId: salesUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_OperationsUser: [
        {
          payload: { roleId: operationsUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SuperUser', id: superUser },
  },
  {
    key: DATA_ENTRY,
    userId: dataEntry,
    Icon: UserIcon,
    label: 'user_DataEntryUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      superUser,
      dataEntry,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager, superUser],
    level: {
      'sub-menu2': [recycler, scrappingFacilityManager, superUser],
      'sub-menu3': [
        admin,
        dataEntry,
        operationsUser,
        salesUser,
        scrappingFacilityEntryUser,
        categoryUser,
      ],
    },
    userView: {
      user_CategoryUser: [
        {
          payload: { roleId: categoryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_SalesUser: [
        {
          payload: { roleId: salesUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_OperationsUser: [
        {
          payload: { roleId: operationsUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_ScrappingFacilityEntryUser: [
        {
          payload: { roleId: scrappingFacilityEntryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SuperUser', id: superUser },
  },
  {
    key: CATEGORY_USER,
    userId: categoryUser,
    Icon: UserIcon,
    label: 'user_CategoryUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      superUser,
      categoryUser,
      dataEntry,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager, superUser],
    level: {
      'sub-menu2': [recycler, scrappingFacilityManager, superUser],
      'sub-menu3': [
        admin,
        categoryUser,
        operationsUser,
        salesUser,
        scrappingFacilityEntryUser,
        dataEntry,
      ],
    },
    userView: {
      user_DataEntryUser: [
        {
          payload: { roleId: dataEntry },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_SalesUser: [
        {
          payload: { roleId: salesUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_OperationsUser: [
        {
          payload: { roleId: operationsUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_ScrappingFacilityEntryUser: [
        {
          payload: { roleId: scrappingFacilityEntryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SuperUser', id: superUser },
  },
  {
    key: SALES_USER,
    userId: salesUser,
    Icon: UserIcon,
    label: 'user_SalesUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      superUser,
      salesUser,
      dataEntry,
      operationsUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager, superUser],
    level: {
      'sub-menu2': [recycler, scrappingFacilityManager, superUser],
      'sub-menu3': [
        admin,
        salesUser,
        operationsUser,
        scrappingFacilityEntryUser,
        dataEntry,
        categoryUser,
      ],
    },
    userView: {
      user_DataEntryUser: [
        {
          payload: { roleId: dataEntry },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_CategoryUser: [
        {
          payload: { roleId: categoryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_OperationsUser: [
        {
          payload: { roleId: operationsUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_ScrappingFacilityEntryUser: [
        {
          payload: { roleId: scrappingFacilityEntryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SuperUser', id: superUser },
  },
  {
    key: OPERATIONS_USER,
    userId: operationsUser,
    Icon: UserIcon,
    label: 'user_OperationsUser',
    sidebar: [
      admin,
      recycler,
      scrappingFacilityManager,
      superUser,
      operationsUser,
      dataEntry,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin, recycler, scrappingFacilityManager, superUser],
    level: {
      'sub-menu2': [recycler, scrappingFacilityManager, superUser],
      'sub-menu3': [
        admin,
        dataEntry,
        categoryUser,
        operationsUser,
        salesUser,
        scrappingFacilityEntryUser,
      ],
    },
    userView: {
      user_DataEntryUser: [
        {
          payload: { roleId: dataEntry },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_CategoryUser: [
        {
          payload: { roleId: categoryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_SalesUser: [
        {
          payload: { roleId: salesUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_ScrappingFacilityEntryUser: [
        {
          payload: { roleId: scrappingFacilityEntryUser },
          hideInProfile: true,
          needParent: true,
        },
      ],
      user_Producer: [
        {
          payload: { roleId: producer, relationType: associate },
          hideInProfile: true,
        },
      ],
      user_AssociatedConsumerList: [
        {
          payload: { roleId: consumer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedCollectionCenter: [
        {
          payload: { roleId: collectionCenter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SuperUser', id: superUser },
  },
  // {
  //   key: ACCOUNTS,
  //   userId: accounts,
  //   Icon: UserIcon,
  //   label: 'user_AccountsUser',
  //   sidebar: [admin, recycler],
  //   addEdit: [admin, recycler],
  //   level: { menu: [recycler], 'sub-menu': [admin] },
  //   userView: {
  //     user_Producer: [
  //       {
  //         payload: { roleId: producer },
  //         hideInProfile: true,
  //         needAdminId: true,
  //       },
  //     ],
  //   },
  //   parent: { label: 'user_ScrappingFacility', id: recycler },
  // },
  // {
  //   key: FINANCE,
  //   userId: finance,
  //   Icon: UserIcon,
  //   label: 'user_FinanceUser',
  //   sidebar: [admin, recycler],
  //   addEdit: [admin, recycler],
  //   level: { menu: [recycler], 'sub-menu': [admin] },
  //   userView: {
  //     user_Producer: [
  //       {
  //         payload: { roleId: producer },
  //         hideInProfile: true,
  //         needAdminId: true,
  //       },
  //     ],
  //   },
  //   parent: { label: 'user_ScrappingFacility', id: recycler },
  // },
  // {
  //   key: COMPLIANCE,
  //   userId: compliance,
  //   Icon: UserIcon,
  //   label: 'user_Compliance',
  //   sidebar: [admin, recycler],
  //   addEdit: [admin, recycler],
  //   level: { menu: [recycler], 'sub-menu': [admin] },
  //   userView: {},
  //   parent: { label: 'user_ScrappingFacility', id: recycler },
  // },
  {
    key: REFURBISHER,
    userId: refurbisher,
    Icon: ProductManufactureIcon,
    label: 'user_MaterialProducer',
    sidebar: [
      admin,
      dealer,
      dealerUser,
      recycler,
      recyclingTechnician,
      refurbisher,
      refurbisherUser,
      trader,
      traderUser,
      supplier,
      supplierUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
      procurement,
      operations,
      sales,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_MaterialProducerTechnician: [
        { payload: { roleId: refurbisherUser } },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: REFURBISHER_USER,
    userId: refurbisherUser,
    Icon: ProductManufactureIcon,
    label: 'user_MaterialProducerTechnician',
    sidebar: [admin, refurbisher],
    addEdit: [admin, refurbisher],
    level: {
      menu: [refurbisher],
      'sub-menu': [admin],
    },
    userView: {
      user_MaterialProducer: [
        { payload: { roleId: refurbisher }, subTitle: 'user_Parent' },
        {
          payload: { roleId: refurbisher, relationType: associate },
          needParent: true,
          subTitle: 'user_Associate',
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_MaterialProducer', id: refurbisher },
  },
  {
    key: PROCUREMENT,
    userId: procurement,
    Icon: FieldEngineerIcon,
    label: 'user_Procurement',
    sidebar: [admin, refurbisher],
    addEdit: [admin, refurbisher],
    level: {
      menu: allUser,
    },
    userView: {
      // user_SPCBGovernmentUser: [{ payload: { roleId: spcbGovUser } }],
    },
    parent: { label: 'user_MaterialProducer', id: refurbisher },
    hidden: loginUserDetails => !isMaterialSteel(loginUserDetails),
  },
  {
    key: OPERATIONS,
    userId: operations,
    Icon: FieldEngineerIcon,
    label: 'user_Operations',
    sidebar: [admin, refurbisher],
    addEdit: [admin, refurbisher],
    level: {
      menu: allUser,
    },
    userView: {
      // user_SPCBGovernmentUser: [{ payload: { roleId: spcbGovUser } }],
    },
    parent: { label: 'user_MaterialProducer', id: refurbisher },
    hidden: loginUserDetails => !isMaterialSteel(loginUserDetails),
  },
  {
    key: SALES,
    userId: sales,
    Icon: FieldEngineerIcon,
    label: 'job_Sales',
    sidebar: [admin, refurbisher],
    addEdit: [admin, refurbisher],
    level: {
      menu: allUser,
    },
    userView: {
      // user_SPCBGovernmentUser: [{ payload: { roleId: spcbGovUser } }],
    },
    parent: { label: 'user_MaterialProducer', id: refurbisher },
    hidden: loginUserDetails => !isMaterialSteel(loginUserDetails),
  },
  {
    key: TRADER,
    userId: trader,
    Icon: ContractorIcon,
    label: 'user_TradingCompany',
    sidebar: [
      admin,
      recycler,
      recyclingTechnician,
      refurbisher,
      refurbisherUser,
      traderUser,
      supplier,
      supplierUser,
      producer,
      producerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
      procurement,
      operations,
      sales,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_TradingCompanyUser: [{ payload: { roleId: traderUser } }],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: TRADER_USER,
    userId: traderUser,
    Icon: ContractorIcon,
    label: 'user_TradingCompanyUser',
    sidebar: [admin, trader],
    addEdit: [admin, trader],
    level: { menu: [trader], 'sub-menu': [admin] },
    userView: {
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Trader', id: trader },
  },
  {
    key: SUPPLIER,
    userId: supplier,
    Icon: TransportContractorIcon,
    label: 'user_Supplier',
    sidebar: [
      admin,
      refurbisher,
      refurbisherUser,
      trader,
      traderUser,
      supplier,
      supplierUser,
      producer,
      producerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      procurement,
      operations,
      sales,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_SupplierUser: [{ payload: { roleId: supplierUser } }],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: SUPPLIER_USER,
    userId: supplierUser,
    Icon: TransportContractorIcon,
    label: 'user_SupplierUser',
    sidebar: [admin, supplier],
    addEdit: [admin, supplier],
    level: { menu: [supplier], 'sub-menu': [admin] },
    userView: {
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier },
          subTitle: 'user_Parent',
        },
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
          needParent: true,
          subTitle: 'user_Associate',
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Supplier', id: supplier },
  },
  {
    key: PRODUCER,
    userId: producer,
    Icon: DigitalRetailerIcon,
    label: 'user_Producer',
    sidebar: [
      admin,
      trader,
      traderUser,
      supplier,
      supplierUser,
      producerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
      recycler,
      recyclingTechnician,
      superUser,
      dataEntry,
      accounts,
      finance,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_ProducerUser: [{ payload: { roleId: producerUser } }],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: PRODUCER_USER,
    userId: producerUser,
    Icon: DigitalRetailerIcon,
    label: 'user_ProducerUser',
    sidebar: [admin, producer],
    addEdit: [admin, producer],
    level: { menu: [producer], 'sub-menu': [admin] },
    userView: {
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Producer', id: producer },
  },
  {
    key: THIRD_PARTY_RECYCLER,
    userId: thirdPartyRecycle,
    Icon: ProductManufactureIcon,
    label: 'user_3rdPartyRecycler',
    sidebar: [
      admin,
      thirdPartyRecycleUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_3rdPartyRecyclerUser: [
        { payload: { roleId: thirdPartyRecycleUser } },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: THIRD_PARTY_RECYCLER_USER,
    userId: thirdPartyRecycleUser,
    Icon: ProductManufactureIcon,
    label: 'user_3rdPartyRecyclerUser',
    sidebar: [admin, thirdPartyRecycle],
    addEdit: [admin, thirdPartyRecycle],
    level: { menu: [thirdPartyRecycle], 'sub-menu': [admin] },
    userView: {
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_3rdPartyRecycler', id: thirdPartyRecycle },
  },
  {
    key: DISPOSER,
    userId: disposer,
    Icon: ContractorIcon,
    label: 'user_Disposer',
    sidebar: [
      admin,
      disposerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_DisposerUser: [{ payload: { roleId: disposerUser } }],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DISPOSER_USER,
    userId: disposerUser,
    Icon: ContractorIcon,
    label: 'user_DisposerUser',
    sidebar: [admin, disposer],
    addEdit: [admin, disposer],
    level: { menu: [disposer], 'sub-menu': [admin] },
    userView: {
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Disposer', id: disposer },
  },
  {
    key: SECOND_HAND_BUYER,
    userId: secondHandBuyer,
    Icon: CustomerIcon,
    label: 'user_SecondHandBuyer',
    sidebar: [
      admin,
      secondHandBuyerUser,
      transporter,
      nationalGov,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: { menu: [admin] },
    userView: {
      user_SecondHandBuyerUser: [{ payload: { roleId: secondHandBuyerUser } }],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: SECOND_HAND_BUYER_USER,
    userId: secondHandBuyerUser,
    Icon: CustomerIcon,
    label: 'user_SecondHandBuyerUser',
    sidebar: [admin, secondHandBuyer],
    addEdit: [admin, secondHandBuyer],
    level: { menu: [secondHandBuyer], 'sub-menu': [admin] },
    userView: {
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_AssociatedTransportContractor: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_SecondHandBuyer', id: secondHandBuyer },
  },
  {
    key: TRANSPORT_CONTRACTOR,
    userId: transporter,
    Icon: TransportContractorIcon,
    label: 'user_TransportContractor',
    sidebar: [
      admin,
      dealer,
      recycler,
      refurbisher,
      refurbisherUser,
      supplier,
      trader,
      producer,
      thirdPartyRecycle,
      disposer,
      secondHandBuyer,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
      procurement,
      operations,
      sales,
    ],
    addEdit: [admin],
    level: { menu: [admin], 'sub-menu': [] },
    userView: {
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedScrappingFacilityList: [
        {
          payload: { roleId: recycler, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedMaterialProducerList: [
        {
          payload: { roleId: refurbisher, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSupplierList: [
        {
          payload: { roleId: supplier, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedTradingCompanyList: [
        {
          payload: { roleId: trader, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedProducerList: [
        {
          payload: { roleId: producer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_Associated3rdPartyRecyclerList: [
        {
          payload: { roleId: thirdPartyRecycle, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedDisposerList: [
        {
          payload: { roleId: disposer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedSecondHandBuyerList: [
        {
          payload: { roleId: secondHandBuyer, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: NATIONAL_GOVERNMENT,
    userId: nationalGov,
    Icon: FieldEngineerIcon,
    label: 'user_NationalGovernment',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealer,
      dealerUser,
      trader,
      traderUser,
      producer,
      producerUser,
      thirdPartyRecycle,
      thirdPartyRecycleUser,
      disposer,
      disposerUser,
      secondHandBuyer,
      secondHandBuyerUser,
      transporter,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: {
      menu: allUser,
    },
    userView: {
      user_NationalGovernmentUser: [{ payload: { roleId: nationalGovUser } }],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: NATIONAL_GOVERNMENT_USER,
    userId: nationalGovUser,
    Icon: FieldEngineerIcon,
    label: 'user_NationalGovernmentUser',
    sidebar: [admin, nationalGov],
    addEdit: [admin, nationalGov],
    level: { menu: [nationalGov], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_NationalGovernment', id: nationalGov },
  },
  {
    key: CPCB_GOVERNMENT,
    userId: cpcbGov,
    Icon: FieldEngineerIcon,
    label: 'user_CPCBGovernment',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealer,
      dealerUser,
      trader,
      traderUser,
      producer,
      producerUser,
      thirdPartyRecycle,
      thirdPartyRecycleUser,
      disposer,
      disposerUser,
      secondHandBuyer,
      secondHandBuyerUser,
      transporter,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: {
      menu: allUser,
    },
    userView: {
      user_CPCBGovernmentUser: [{ payload: { roleId: cpcbGovUser } }],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: CPCB_GOVERNMENT_USER,
    userId: cpcbGovUser,
    Icon: FieldEngineerIcon,
    label: 'user_CPCBGovernmentUser',
    sidebar: [admin, nationalGov],
    addEdit: [admin, nationalGov],
    level: { menu: [nationalGov], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_CPCBGovernment', id: cpcbGov },
  },
  {
    key: SPCB_GOVERNMENT,
    userId: spcbGov,
    Icon: FieldEngineerIcon,
    label: 'user_SPCBGovernment',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealer,
      dealerUser,
      trader,
      traderUser,
      producer,
      producerUser,
      thirdPartyRecycle,
      thirdPartyRecycleUser,
      disposer,
      disposerUser,
      secondHandBuyer,
      secondHandBuyerUser,
      transporter,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: {
      menu: allUser,
    },
    userView: {
      user_SPCBGovernmentUser: [{ payload: { roleId: spcbGovUser } }],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: SPCB_GOVERNMENT_USER,
    userId: spcbGovUser,
    Icon: FieldEngineerIcon,
    label: 'user_SPCBGovernmentUser',
    sidebar: [admin, spcbGov],
    addEdit: [admin, spcbGov],
    level: { menu: [spcbGov], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_SPCBGovernment', id: spcbGov },
  },
  {
    key: DISTRICT_GOVERNMENT,
    userId: districtGov,
    Icon: FieldEngineerIcon,
    label: 'user_DistrictGovernment',
    sidebar: [
      admin,
      consumer,
      consumerUser,
      dealer,
      dealerUser,
      trader,
      traderUser,
      producer,
      producerUser,
      thirdPartyRecycle,
      thirdPartyRecycleUser,
      disposer,
      disposerUser,
      secondHandBuyer,
      secondHandBuyerUser,
      transporter,
      nationalGovUser,
      cpcbGov,
      cpcbGovUser,
      spcbGov,
      spcbGovUser,
      districtGov,
      districtGovUser,
    ],
    addEdit: [admin],
    level: {
      menu: allUser,
    },
    userView: {
      user_DistrictGovernmentUser: [{ payload: { roleId: districtGovUser } }],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DISTRICT_GOVERNMENT_USER,
    userId: districtGovUser,
    Icon: FieldEngineerIcon,
    label: 'user_DistrictGovernmentUser',
    sidebar: [admin, districtGov],
    addEdit: [admin, districtGov],
    level: { menu: [districtGov], 'sub-menu': [admin] },
    userView: {},
    parent: { label: 'user_DistrictGovernment', id: districtGov },
  },
]

const sidebarMenus = [
  {
    key: HOME,
    Icon: HomeIcon,
    label: 'menu_Home',
    sidebar: allUser,
  },
  {
    key: DASHBOARD,
    Icon: DashboardIcon,
    label: 'job_Dashboard',
    sidebar: [procurement, operations, sales, refurbisher],
  },
  {
    key: DASHBOARD_INDIA,
    Icon: DashboardIcon,
    label: 'menu_DashboardIndia',
    sidebar: [producer],
  },
  {
    key: DASHBOARD_STATS,
    Icon: DashboardIcon,
    label: 'dash_stats',
    sidebar: [
      recycler,
      recyclingTechnician,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      // producer,
    ],
  },
  {
    key: SEARCH_REACT_FLOW,
    Icon: DashboardIcon,
    label: 'txt_Search',
    sidebar: [refurbisher, producer],
  },

  {
    key: LIVE_BOARD,
    Icon: DashboardIcon,
    label: 'menu_LiveBoard',
    sidebar: [refurbisher],
    hidden: loginUserDetails =>
      !include(['job_Plastic'], loginUserDetails?.materialType),
    children: [
      {
        key: LIVE_BOARD_PATH.replace(':boardNumber', '1'),
        Icon: DashboardIcon,
        label: 'menu_LiveBoard1',
        sidebar: [refurbisher],
      },
      {
        key: LIVE_BOARD_PATH.replace(':boardNumber', '2'),
        Icon: DashboardIcon,
        label: 'menu_LiveBoard2',
        sidebar: [refurbisher],
      },
    ],
  },
  {
    key: USER_TXT,
    Icon: UserIcon,
    label: 'menu_User',
    sidebar: allUser,
    children: userChildrenList.map(prop => ({
      ...prop,
      key: `${USER_TXT}/${prop.key}`,
    })),
  },
  {
    key: INVENTORY,
    Icon: InventoryIcon,
    label: 'menu_Inventory',
    sidebar: allUser,
    addEdit: allUser,
  },
  {
    key: JOBS,
    Icon: ClipboardIcon,
    label: 'menu_Jobs',
    sidebar: allUser,
    addEdit: allUser,
  },
  // {
  //   key: CATALOGUE,
  //   Icon: CatalogueMenuIcon,
  //   label: 'menu_CatalogueManagement',
  //   sidebar: allUser,
  //   addEdit: [admin],
  // },
  {
    key: REPORT,
    Icon: ReportIcon,
    label: 'menu_Report',
    sidebar: [
      recycler,
      dataEntry,
      superUser,
      finance,
      accounts,
      scrappingFacilityManager,
      operationsUser,
      salesUser,
      scrappingFacilityEntryUser,
      categoryUser,
    ],
  },
  {
    key: 'dataView',
    Icon: DataviewIcon,
    label: 'menu_DataView',
    disabled: true,
    sidebar: allUser,
  },
  {
    key: DATA_VISUALIZATION,
    Icon: DataviewIcon,
    label: 'menu_DataViz',
    disabled: false,
    sidebar: [],
  },
  {
    key: BUCKET_MANAGEMENT,
    Icon: DataviewIcon,
    label: 'menu_BucketManagement',
    disabled: false,
    sidebar: [recycler, superUser, scrappingFacilityManager],
  },
  {
    key: CATEGORY_MANAGEMENT,
    Icon: DataviewIcon,
    label: 'menu_CategoryManagement',
    disabled: false,
    sidebar: [recycler, superUser, scrappingFacilityManager],
  },
  {
    key: SETTINGS,
    Icon: SettingOutlined,
    label: 'txt_Settings',
    sidebar: [procurement, operations, sales, refurbisher],
    hidden: loginUserDetails => {
      return !include(
        ['job_Plastic'],
        loginUserDetails?.materialTypes?.[0]?.materialTypeKey,
      )
    },
  },
  {
    key: TRACE_SAMPLE,
    Icon: TraceIcon,
    label: 'Trace (Sample)',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096], Number(loginUserDetails?.id)),
  },
  {
    key: TRACE_ACTUAL,
    Icon: TraceIcon,
    label: 'Trace(Actual)',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096], Number(loginUserDetails?.id)),
  },
  {
    key: PLASTIC_TRACE_SAMPLE,
    Icon: TraceIcon,
    label: 'Plastic Trace(Sample)',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096], Number(loginUserDetails?.id)),
  },
  {
    key: PLASTIC_TRACE_ACTUAL,
    Icon: TraceIcon,
    label: 'Plastic Trace(Actual)',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096], Number(loginUserDetails?.id)),
  },
  {
    key: TRACE_END_TO_END,
    Icon: TraceIcon,
    label: 'Trace (End-to-End)',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096, 16671], Number(loginUserDetails?.id)),
  },
  {
    key: TRACE_END_TO_END2,
    Icon: TraceIcon,
    label: 'Trace (End-to-End) 2',
    sidebar: allUser,
    hidden: loginUserDetails =>
      !include([10325, 15096], Number(loginUserDetails?.id)),
  },
  {
    key: VEHICLE_SALES,
    Icon: DashboardIcon,
    label: 'Vehicle Sales',
    sidebar: allUser,
    hidden: loginUserDetails => !include([10325], Number(loginUserDetails?.id)),
  },
]

const buildingAddEditPermission = [admin]

export { buildingAddEditPermission, sidebarMenus, userChildrenList }
